import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from '../../contexts/AuthContext';
import ProtectedRoute from '../../components/ProtectedRoute';
import RoleProtectedRoute from '../../components/RoleProtectedRoute';
import AdminLayout from './layouts/AdminLayout';
import Dashboard from './pages/Dashboard';
import SiteSettings from './pages/SiteSettings';
import RBACManagement from './pages/RBACManagement';
import ActivityLogs from './pages/ActivityLogs';
import AlumniManagement from './pages/AlumniManagement';
import AlumniDetail from './pages/AlumniDetail';
import AlumniEdit from './pages/AlumniEdit';
import NewsManagement from './pages/NewsManagement';
import AdminUserManagement from './pages/AdminUserManagement';
import AlumniUserManagement from './pages/AlumniUserManagement';
import UserProfile from './pages/UserProfile';
import ConsentManagementPage from './pages/ConsentManagementPage';
import LegalDocumentsPage from './pages/LegalDocumentsPage';
import MasterDataManagement from './pages/MasterDataManagement';
import EducationMasterData from './pages/EducationMasterData';
import LineBotManagement from './pages/LineBotManagement';
import MessageManagement from './pages/MessageManagement';
import Login from './pages/Login';

function RootRedirect() {
  const { user, isLoading } = useAuth();
  
  if (isLoading) return null;
  
  return <Navigate to={user ? "/dashboard" : "/login"} replace />;
}

function AdminApp() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<RootRedirect />} />
        <Route path="/login" element={<Login />} />
        <Route
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/dashboard" element={
            <RoleProtectedRoute path="/dashboard">
              <Dashboard />
            </RoleProtectedRoute>
          } />
          <Route path="/alumni" element={
            <RoleProtectedRoute path="/alumni">
              <AlumniManagement />
            </RoleProtectedRoute>
          } />
          <Route path="/alumni/:id" element={
            <RoleProtectedRoute path="/alumni/:id">
              <AlumniDetail />
            </RoleProtectedRoute>
          } />
          <Route path="/alumni/edit/:id" element={
            <RoleProtectedRoute path="/alumni/edit/:id">
              <AlumniEdit />
            </RoleProtectedRoute>
          } />
          <Route path="/news" element={
            <RoleProtectedRoute path="/news">
              <NewsManagement />
            </RoleProtectedRoute>
          } />
          <Route path="/admin-users" element={
            <RoleProtectedRoute path="/admin-users">
              <AdminUserManagement />
            </RoleProtectedRoute>
          } />
          <Route path="/alumni-users" element={
            <RoleProtectedRoute path="/alumni-users">
              <AlumniUserManagement />
            </RoleProtectedRoute>
          } />
          <Route path="/profile" element={
            <RoleProtectedRoute path="/profile">
              <UserProfile />
            </RoleProtectedRoute>
          } />
          <Route path="/consent-management" element={
            <RoleProtectedRoute path="/consent-management">
              <ConsentManagementPage />
            </RoleProtectedRoute>
          } />
          <Route path="/legal-documents" element={
            <RoleProtectedRoute path="/legal-documents">
              <LegalDocumentsPage />
            </RoleProtectedRoute>
          } />
          <Route path="/settings" element={
            <RoleProtectedRoute path="/settings">
              <SiteSettings />
            </RoleProtectedRoute>
          } />
          <Route path="/rbac" element={
            <RoleProtectedRoute path="/rbac">
              <RBACManagement />
            </RoleProtectedRoute>
          } />
          <Route path="/logs" element={
            <RoleProtectedRoute path="/logs">
              <ActivityLogs />
            </RoleProtectedRoute>
          } />
          <Route path="/master-data" element={
            <RoleProtectedRoute path="/master-data">
              <MasterDataManagement />
            </RoleProtectedRoute>
          } />
          <Route path="/education-data" element={
            <RoleProtectedRoute path="/education-data">
              <EducationMasterData />
            </RoleProtectedRoute>
          } />
          <Route path="/line-bot" element={
            <RoleProtectedRoute path="/line-bot">
              <LineBotManagement />
            </RoleProtectedRoute>
          } />
          <Route path="/messages" element={
            <RoleProtectedRoute path="/messages">
              <MessageManagement />
            </RoleProtectedRoute>
          } />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}

export default AdminApp;
